<ng-container *ngIf="!customTemplate">
    <button class="ft-link-underline ft-btn-action-secondary">{{name}}</button>
</ng-container>
<ng-container *ngIf="customTemplate">
    <ng-container *ngTemplateOutlet="customTemplate"></ng-container>
</ng-container>